
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.066 3.448a.5.5 0 01-.5-.5V1.334a.5.5 0 011 0v1.614a.5.5 0 01-.5.5zM9.066 12.19a.5.5 0 01-.5-.5v-1.35a.5.5 0 111 0v1.35a.5.5 0 01-.5.5zM9.066 8.55a.5.5 0 01-.5-.5V4.838a.5.5 0 011 0V8.05a.5.5 0 01-.5.5z","fill":"#666"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"15","height":"13"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.666.667h14.333v11.667H.666V.667z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.666 8.37v1.292c0 .922.762 1.672 1.699 1.672H12.3c.936 0 1.698-.75 1.698-1.672V8.37A1.94 1.94 0 0112.548 6.5c0-.895.617-1.65 1.451-1.869V3.338c0-.921-.762-1.671-1.699-1.671H3.365c-.936 0-1.698.75-1.698 1.671l-.001 1.346c.845.207 1.451.931 1.451 1.817A1.94 1.94 0 011.666 8.37zm10.635 3.964H3.365c-1.488 0-2.699-1.199-2.699-2.672V7.934a.5.5 0 01.5-.5.943.943 0 00.951-.933c0-.5-.409-.877-.951-.877a.498.498 0 01-.5-.5V3.338c0-1.472 1.211-2.671 2.7-2.671H12.3c1.488 0 2.699 1.199 2.699 2.671v1.73a.499.499 0 01-.5.5.943.943 0 00-.951.933c0 .515.427.933.951.933a.5.5 0 01.5.5v1.728c0 1.473-1.21 2.672-2.698 2.672z","fill":"#666"}})])])
          )
        }
      }
    